import React from "react";
import { Helmet } from "react-helmet";
import Navbar from '../components/navbar';
import TopBanner from '../components/top-banner';
import Footer from '../components/footer';
import Vehicle from "../components/vehicle";
import SocialMediaFixed from "../components/socialmedia-fixed";


const VehiclePage = () => {

    return (
        <>
            <Helmet>
                <title>MP Holidays Vehicle Rentals - Book Cars & Buses for Your Trip</title>
                <meta name="description" content="Hire cars, buses, and tempo travelers for your Madhya Pradesh trip with MP Holidays. Get affordable and comfortable travel options for sightseeing and tours." />
                <meta name="keywords" content="MP vehicle rental, car hire Madhya Pradesh, bus rental MP, tempo traveler hire MP, MP taxi service, travel vehicle booking MP, tourist vehicle MP, Madhya Pradesh transport services" />
                <link rel="canonical" href="https://mpholidays.online/vehicle" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "CarRental",
                        "name": "MP Holidays Vehicle Rentals",
                        "url": "https://mpholidays.online/vehicle",
                        "description": "Affordable car, bus, and tempo traveler rentals for Madhya Pradesh trips. Comfortable travel solutions for sightseeing and tours.",
                        "provider": {
                            "@type": "Organization",
                            "name": "MP Holidays",
                            "url": "https://mpholidays.online"
                        }
                    })}
                </script>
            </Helmet>


            <TopBanner />
            <Navbar />
            <Vehicle />
            <Footer />
            <SocialMediaFixed />
        </>
    );
};

export default VehiclePage;
